<template lang="pug">
	.tokuSho
		button(@click='moveToScta()')
			span {{$t('pages.scta')}}
			fa-icon(:icon="['fal', 'external-link-alt']")
</template>

<script>
export default {
  methods: {
    moveToScta() {
      this.$router.push(this.localePath('scta'))
    },
  },
}
</script>

<style>
.tokuSho button span {
  margin-right: 8px;
  font-size: 14px;
  text-decoration-line: underline;
}
</style>
